import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AuthService } from '@core/services/auth.service';
import { SessionTimeoutService } from '@core/session-timeout.service';

@Component({
  standalone: false,
  selector: 'gstar-home',
  templateUrl: './home.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeComponent {
  private readonly sessionTimeoutservice = inject(SessionTimeoutService);
  private readonly authService = inject(AuthService);

  constructor() {
    this.sessionTimeoutservice.sessionInitialize();
    this.authService.automaticTokenRefreshInitialize();
  }
}
